<template>
    <div class="home-page">
        <div class="router-box">
            <router-view>
            </router-view>
        </div>
        <van-tabbar v-model="active" class="active_tab">
            <van-tabbar-item
                    v-for="(item,index) in tabbars"
                    :key="index"
                    @click="tab(index,item.name)"
            >
                <span :class="currIndex == index ? active:''">{{item.title}}</span>
                <template slot="icon" slot-scope="props">
                    <img :src="props.active ? item.active : item.normal">
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>

    export default {
        beforeRouteUpdate (to, from, next) {
            if(to.name === 'Index'){
                this.active = 0
            }else if(to.name === 'myPreservation' || to.name === 'myRelievPreservation' || to.name === 'myContinuationPreservation'){
                this.active = 1
            }else if(to.name === 'myGuarantee'){
                this.active = 2
            }else if(to.name === 'personCenter'){
                this.active = 3
            }
            next()
        },
        data() {
            return {
                currIndex: 0,
                active: 0,
                tabbars: [
                    {
                        name: "/home/index",
                        title: "首页",
                        normal: require('../../assets/image/icon-sy.png'),
                        active: require('../../assets/image/icon-syS.png'),
                    },
                    {
                        name: "/home/myApply",
                        title: "我的申请",
                        normal: require('../../assets/image/myApply-h.png'),
                        active: require('../../assets/image/myApply.png'),
                    },
                    /*{
                        name: "/home/myPreservation",
                        title: "我的保全申请",
                        normal: require('../../assets/image/icon-wdbqsq.png'),
                        active: require('../../assets/image/icon-wdbqsqS.png'),
                    },
                    {
                        name: "/home/myGuarantee",
                        title: "我的担保申请",
                        normal: require('../../assets/image/icon-wddbsq.png'),
                        active: require('../../assets/image/icon-wddbsqS.png'),
                    },*/
                    {
                        name: "/home/personCenter",
                        title: "个人中心",
                        normal: require('../../assets/image/icon-grzx.png'),
                        active: require('../../assets/image/icon-grzxS.png'),
                    },
                ],
            }
        },
        mounted() {

        },
        methods: {
            tab(index, val) {
                this.currIndex = index;
                this.$router.push(val);
            },
            removeUseless: function () {
                sessionStorage.removeItem('fcheckedFy');
                sessionStorage.removeItem('fcheckedFyKey');
                // sessionStorage.removeItem('selectay');
                // sessionStorage.removeItem('Ayxw');
            },
        },
        created() {
            if (this.$route.name === "Index") {
                this.currIndex = 0
            } else if (this.$route.name === "myPreservation" || this.$route.name === "myRelievPreservation" || this.$route.name === "myContinuationPreservation") {
                this.active = 1;
            } else if (this.$route.name === "myGuarantee") {
                this.active = 2;
            } else if (this.$route.name === "personCenter") {
                this.active = 3;
            }
            this.removeUseless();
        },
    }
</script>

<style lang="less" rel="stylesheet/less" scoped>
    .home-page {
        width: 100%;
        height: 100%;
        position: relative !important;
        z-index:99;
    }

    .router-box {
        width: 100%;
        height: calc(100% - 100px / 2);
    }

    /deep/.active_tab{
        position: relative !important;
        z-index:99;
    }

</style>
